var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{'button__block': _vm.block},attrs:{"disabled":_vm.isDisabledState},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('loader',{attrs:{"fixed":false}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }